import { ButtonBase, FontIconName } from "client/Components";
import { WorkspaceHeaderStyle } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { ReactElement } from "react";
import { Render } from "./Render";
import styles from "./TitleBarButton.module.less";

export type TitleBarButtonProps = {
	icon: FontIconName;
	text?: string;
	headerStyle: WorkspaceHeaderStyle;
	onClick(): void;
	trackingId: string;
};

export const TitleBarButton = (props: TitleBarButtonProps): ReactElement => {
	const {
		onClick,
		trackingId,
		...restOfTheProps
	} = props;

	return (
		<ButtonBase
			onClick={onClick}
			className={styles.root}
			trackingId={trackingId}
		>
			<Render
				{...restOfTheProps}
			/>
		</ButtonBase>
	);
};
TitleBarButton.displayName = "TitleBarButton";